import React from 'react';
import './Lander.css';

export default function Lander() {
    const scrollToFeatures = () => {
        const el = document.getElementsByClassName("cards-container")[0];
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div className="lander-container">
            <section className="landing-section">
                <div className="landing-content-container">
                    <div className="landing-content-left">
                        <div className="content">
                            <h3 className="landing-rating">
                                ⭐ 4.6 Degerlendirme
                            </h3>
                            <h1 className="landing-header">
                                5,000₺ Kısa Süreli Full Oto Ekspertiz Hizmeti
                            </h1>
                            <div className="content-text">
                                <p id="content-text-top">Aracınızın Durumunu öğrenin. <br /> detaylı rapor, motor analizi ve ekspertiz sonuçları.</p>
                                <p id="content-text-bottom">Güvenli, hızlı ve tarafsız oto ekspertiz.</p>
                            </div>
                            <div className="landing-content-buttons">
                                <button onClick={scrollToFeatures} className="packages-btn">Paketlerimiz</button>
                                <a href="tel:+905013341032" className="call-btn" aria-label="Bizi arayin, telefon numarası">
                                    <span className="btn-label">Bizi arayın</span>
                                    <span className="btn-phone">+90 501 334 10 32</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="landing-content-right">
                        <div className="car-components-top">
                            <div className="bubble"><p>Motor</p></div>
                            <div className="bubble"><p>Sasi</p></div>
                            <div className="bubble"><p>Bagaj</p></div>
                        </div>
                        <div className="landing-image-container">
                            <div className="car-glow">
                            </div>
                            <img
                                src={require("/Users/oguzhanozkan/Desktop/Isparta Gezen Adam/isparta-gezen-adam/src/Assets/landing-car.png")}
                                alt="Landing Car"
                                className="landing-car-image"
                            />


                        </div>
                        <div className="car-components-bottom">
                            <div className="bubble"><p>Kaporta</p></div>
                            <div className="bubble"><p>Fren</p></div>
                            <div className="bubble"><p>Elektronik</p></div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}